import * as React from 'react'
// libs
import { change } from 'redux-form'
import { formValueSelector } from 'redux-form'
import { useDispatch, useSelector } from 'react-redux'
// constants
import { Forms } from 'constants/forms'
// views
import {
  Header,
  Wrapper,
  CloseIcon,
  CheckedIcon,
  PermissionTitle,
  PermissionWrapper,
  PermissionsContainer
} from './views'
// types
import { RootState } from 'store/store'
// utils
import find from 'lodash/fp/find'
import pipe from 'lodash/fp/pipe'
import getFp from 'lodash/fp/get'

// types
interface Props {
  closePopup: () => void
  fieldValue: Record<string, any>
  selectProps: Record<string, any>
}

const MemberPermissions: React.FC<Props> = ({ closePopup, fieldValue, selectProps }) => {
  const [objectSecurityId, setObjectSecurityId] = React.useState<string>()

  const dispatch = useDispatch()

  const selector = formValueSelector(selectProps.meta.form)

  const { currentValue, objectSecurities } = useSelector((state: RootState) => ({
    currentValue: selector(state, selectProps.name),
    objectSecurities: state.objectSecurities.data.filter(({ active, objectEntityId, objectEntity: { apiName } }) => {
      if (!selectProps.field.objectEntityId) {
        if (selectProps.meta.form === Forms.RISK_TEMPLATE_FORM) {
          return active && apiName === 'risks'
        }
        return active && apiName === 'plans'
      }
      return active && objectEntityId === selectProps.field.objectEntityId
    })
  }))

  const handleSetPermission = (id: string) => {
    let value

    if (Array.isArray(selectProps.value)) {
      value = selectProps.value.map((item) => {
        if (item.label === fieldValue.label) {
          return { ...fieldValue, objectSecurityId: id }
        }
        return item
      })
    } else {
      value = { ...fieldValue, objectSecurityId: id }
    }

    setObjectSecurityId(id)
    dispatch(change(selectProps.meta.form, selectProps.name, value))
  }

  React.useEffect(() => {
    if (!objectSecurityId) {
      let id

      if (Array.isArray(currentValue)) {
        id = pipe(
          find(({ value }) => value === fieldValue.value),
          getFp('objectSecurityId')
        )(currentValue)
      } else {
        id = fieldValue?.objectSecurityId
      }

      id && setObjectSecurityId(id)
    }
  }, [])

  return (
    <Wrapper>
      <Header>
        <span>Member Permissions</span>
        <CloseIcon onClick={closePopup} />
      </Header>
      <PermissionsContainer>
        {objectSecurities.map(({ id, name, description }) => {
          const isActive = objectSecurityId === id

          return (
            <PermissionWrapper key={id} isActive={isActive} onClick={() => handleSetPermission(id)}>
              <PermissionTitle>
                <span>{name}</span>
                {isActive && <CheckedIcon />}
              </PermissionTitle>
              <span>{description}</span>
            </PermissionWrapper>
          )
        })}
      </PermissionsContainer>
    </Wrapper>
  )
}

export default MemberPermissions
